var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAlertUiTranslation } from '../../../../../ui/hooks';
import { getAlertIcon } from '../../../../../ui/utils';
import { CardGrid } from '@juvare/common-web-ui/CardGrid';
import { IconCard } from '@juvare/common-web-ui/Cards';
import ClearIcon from '@mui/icons-material/Clear';
import LaunchIcon from '@mui/icons-material/Launch';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useAlertServiceClient } from '../../hooks';
import AlertCard from './AlertCard';
import { detectMovedItem } from './detectMovedItem';
const AlertCardList = (props) => {
    const [loading, setLoading] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState();
    const alertServiceClient = useAlertServiceClient();
    const { t } = useAlertUiTranslation();
    const [items, setItems] = React.useState([]);
    const handleClear = () => {
        setSearchValue('');
    };
    const loadData = useCallback(() => {
        setLoading(true);
        const filterData = {
            pinned: true,
            statuses: ['template'],
        };
        if (searchValue) {
            filterData.searchText = searchValue.trim();
        }
        alertServiceClient
            .getAlerts({ offset: 0, limit: 1000, filterData, sortColumnDesc: false, sortColumnKey: 'orderIndex' })
            .then((result) => {
            setItems(result.items);
        })
            .finally(() => {
            setLoading(false);
        });
    }, [alertServiceClient, searchValue]);
    React.useEffect(() => {
        loadData();
    }, [loadData, props.reloadFlag]);
    React.useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            if (searchValue != null) {
                loadData();
            }
        }, 300);
        return () => {
            window.clearTimeout(timeoutId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);
    const renderCard = (cardInGridProps, item) => {
        const TemplateIcon = getAlertIcon(item.icon);
        const color = item.color || 'grey';
        return (React.createElement(IconCard, Object.assign({}, cardInGridProps, { icon: React.createElement(TemplateIcon, null), color: color, iconColor: color, dragHandle: true, actions: [
                {
                    icon: React.createElement(LaunchIcon, null),
                    onClick: () => props.handleSelect(item.id),
                    ariaLabel: t('pages.toolbar.template.use'),
                },
            ], "data-test": 'use-template-button' }),
            React.createElement(AlertCard, { item: item })));
    };
    function onChange(prevItems, newItems) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = detectMovedItem(prevItems, newItems);
            if (result) {
                try {
                    yield alertServiceClient.orderAlert(result.changedItemId, result.newOrderIndex);
                }
                catch (error) {
                    console.error('Failed to update order', error);
                }
                setItems(result.updatedItems);
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { p: 2, pb: 1 } },
            React.createElement(TextField, { value: searchValue, fullWidth: true, placeholder: t('common.search'), InputProps: {
                    size: 'small',
                    startAdornment: (React.createElement(InputAdornment, { position: 'start' },
                        React.createElement(SearchIcon, null))),
                    endAdornment: (React.createElement(IconButton, { sx: { visibility: searchValue ? 'visible' : 'hidden' }, onClick: handleClear, "aria-label": t('common.clear') },
                        React.createElement(ClearIcon, null))),
                }, onChange: (event) => setSearchValue(event.target.value), "data-test": 'search-input' })),
        items && items.length === 0 && !loading && React.createElement(Typography, { p: 1 }, t('pages.newFromTemplate.noTemplates')),
        loading ? (React.createElement(Typography, { p: 1 }, "Loading...")) : (React.createElement(Box, { sx: { p: 1.5 } },
            React.createElement(CardGrid, { cards: items, gap: 2, columns: { xs: 1 }, editable: true, renderCard: renderCard, onChange: (changed) => onChange(items, changed) })))));
};
export default AlertCardList;
